import React from 'react'
import {
  Accordion,
  AccordionSummary,
  IconButton,
  Typography,
} from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { originalIcons } from '@shared/components/icons/icons'
import AlertRequirementAlert from './audit-requirement-alert.component'
import { useFormContext } from 'react-hook-form'
import { RequirementAlert } from '@shared/types'

const AccordionIcon = ({ expanded }: { expanded: boolean }) => {
  return expanded ? <originalIcons.Indeterminate /> : <originalIcons.Add />
}

export const AlertComponent = ({
  isCalendarDialogOpen,
  setIsCalendarDialogOpen,
  onRefresh,
  isResourceEdit,
}: {
  isCalendarDialogOpen: boolean
  setIsCalendarDialogOpen: (expanded: boolean) => void
  isResourceEdit: boolean
  onRefresh: () => void
}) => {
  const { watch } = useFormContext()
  const alert = watch('alert') as RequirementAlert
  const requirementBaseID = watch('requirementBaseID')
  const classes = useStyles()

  const handleToggle = (_: any, expanded: boolean) => {
    setIsCalendarDialogOpen(!isCalendarDialogOpen)
  }

  return (
    <Accordion
      component="div"
      variant="outlined"
      className={classes.wrapper}
      expanded
      onChange={(e) => e.preventDefault()}
    >
      <AccordionSummary onClick={(e) => e.preventDefault()}>
        <Typography color="textSecondary">Alert</Typography>
        <IconButton
          color="primary"
          component="span"
          className={classes.addIcon}
          onClick={(e) => {
            e.stopPropagation()
            handleToggle(e, !isCalendarDialogOpen)
          }}
          size="large"
          disabled={!!alert}
        >
          <AccordionIcon expanded={isCalendarDialogOpen} />
        </IconButton>
        <AlertRequirementAlert
          isCalendarDialogOpen={isCalendarDialogOpen}
          setIsCalendarDialogOpen={setIsCalendarDialogOpen}
          requirementBaseID={requirementBaseID}
          alertExpirationDate={alert?.expirationDate ?? null}
          onRefresh={onRefresh}
          isResourceEdit={isResourceEdit}
        />
      </AccordionSummary>
    </Accordion>
  )
}

const useStyles = makeStyles(() => {
  return {
    wrapper: {
      marginTop: 15,
      position: 'relative',
    },
    addIcon: {
      position: 'absolute',
      top: 0,
      right: 10,
    },
  }
})
